import React, { useContext, useEffect, useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  IconButton,
} from "@mui/material"
import PropTypes from "prop-types"
import i18n from "i18n"
import CloseIcon from "@mui/icons-material/Close"
import AuthContext from "context/auth/authContext"
import Chapter from "./Chapter"
import { API, Auth } from "aws-amplify"

const fetchChapter = async ({ projectId, parentId, typeBudget }) => {
  const SERVICE_BUDGET = "service-budget"
  const path = `/project/${projectId}?parentId=${parentId}`
  const headers = {
    "Content-Type": "application/json",
    Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
    "Access-Control-Allow-Origin": "*",
  }
  const response = await API.get(SERVICE_BUDGET, path, { headers })
  return response
}

const Loader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 4,
      }}
    >
      <CircularProgress sx={{ mb: 2 }} />
      <Typography>{i18n.t("Cargando...")}</Typography>
      <Typography variant="body2" color="text.secondary">
        {i18n.t("Esta acción puede tardar unos segundos")}
      </Typography>
    </Box>
  )
}

const ModalSearchParts = ({
  open,
  setOpen,
  projectInfo,
  selectedParts,
  setSelectedParts,
  handleAddFromParts,
  readOnly = false,
}) => {
  const { user, getUser } = useContext(AuthContext)
  const [typeBudget, setTypeBudget] = useState("cliente")
  const [loadingTree, setLoadingTree] = useState(true)
  const [chapters, setChapters] = useState([])

  const width = 96
  const disabled = readOnly || !(selectedParts.length > 0)

  useEffect(() => {
    if (!user) {
      getUser
    }
  }, [])

  useEffect(() => {
    const loadChapters = async () => {
      if (projectInfo && open) {
        setSelectedParts([])
        setLoadingTree(true)
        const response = await fetchChapter({
          projectId: projectInfo.projectId,
          parentId: "root",
          typeBudget,
        })
        setChapters(response.chapters)
        setLoadingTree(false)
      }
    }
    loadChapters()
  }, [typeBudget, open])

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { height: "80vh", maxHeight: "800px" },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="h6">{projectInfo?.name}</Typography>
          <Typography variant="body2" color="text.secondary">
            {i18n.t("Selecciona los conceptos que quieres añadir")}
          </Typography>
        </Box>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 2 }}>
        {loadingTree ? (
          <Loader />
        ) : chapters.length > 0 ? (
          <Box sx={{ p: 2 }}>
            {chapters.map((chapter, index) => (
              <Chapter
                chapter={chapter}
                key={index}
                typeBudget={typeBudget}
                fetchChapter={fetchChapter}
                width={width}
                selectedParts={selectedParts}
                setSelectedParts={setSelectedParts}
              />
            ))}
          </Box>
        ) : (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <Typography color="text.secondary">
              {i18n.t("No hay capítulos disponibles")}
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "space-between", px: 3, py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {selectedParts.length > 0
            ? `${i18n.t("Has seleccionado")} ${selectedParts.length} ${i18n.t("partidas")}`
            : ""}
        </Typography>
        <Box>
          <Button onClick={handleClose} color="secondary" sx={{ mr: 1 }}>
            {i18n.t("common.cancel")}
          </Button>
          <Button
            onClick={handleAddFromParts}
            variant="contained"
            disabled={disabled}
            sx={{
              backgroundColor: disabled ? "#AFAFB0" : "#F1CA2C",
              color: "#000",
              "&:hover": {
                backgroundColor: disabled ? "#AFAFB0" : "#e0b800",
              },
            }}
          >
            {i18n.t("Añadir partidas")}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

ModalSearchParts.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  projectInfo: PropTypes.object.isRequired,
  selectedParts: PropTypes.array.isRequired,
  setSelectedParts: PropTypes.func.isRequired,
  handleAddFromParts: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
}

export default ModalSearchParts
